import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'attendance-settings'

const initialState = {
  list: null,
}

export const search = createApiAction(
  'attendance/settings/search',
  client.search('/api/attendance/status'),
)

export const update = createApiAction(
  'attendance/settings/update',
  client.update('/api/attendance/status/:id'),
)

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
      })
      .addCase(update.fulfilled, (state, action) => {
        const found = state.list?.find(item => item.id === action.payload.id)
        state.list = found
          ? state.list.map(item => (found.id === item.id ? action.payload : item))
          : [...state.list, action.payload]
      })
  },
})

export default sessionSlice.reducer